import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { STORE_SECTIONS, StoreDetailPage } from "@/features/stores/store-detail-page";

export const Route = createFileRoute("/_authenticated/stores/$storeId")({
  validateSearch: z.object({ section: z.enum(STORE_SECTIONS).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Store · Rogue Admin" }] }),
  component: StoreDetailPage,
});
